// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import Typography from "@mui/material/Typography";

// Constants
import { eyeTypeEnums } from "src/constants/enums";

type SelectEyeRadioType = {
  isDisabled?: boolean;
  showBoth?: boolean;
  selectedEye: string;
  onChangeEye: (input: string) => void;
};

const SelectEyeRadio = ({
  isDisabled = false,
  showBoth = false,
  selectedEye,
  onChangeEye,
}: SelectEyeRadioType) => {
  const { t } = useTranslation();
  const { BOTH, LEFT, RIGHT } = eyeTypeEnums;

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
      <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
        {t("Select Eye")}
      </Typography>

      {showBoth && (
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Radio
            disabled={isDisabled}
            checked={selectedEye === BOTH}
            onChange={() => {
              onChangeEye(BOTH);
            }}
            value="both eye"
            name="radio-buttons"
            inputProps={{ "aria-label": "both eye" }}
            sx={{
              padding: "0px",
              "&.MuiButtonBase-root.MuiRadio-root": {
                color: "#E2772E",
              },
            }}
          />
          <Typography sx={{ fontSize: "14px" }}>{t("Both")}</Typography>
        </Box>
      )}

      <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <Radio
          disabled={isDisabled}
          checked={selectedEye === LEFT}
          onChange={() => {
            onChangeEye(LEFT);
          }}
          value="left eye"
          name="radio-buttons"
          inputProps={{ "aria-label": "left eye" }}
          sx={{
            padding: "0px",
            "&.MuiButtonBase-root.MuiRadio-root": {
              color: "#E2772E",
            },
          }}
        />
        <Typography sx={{ fontSize: "14px" }}>{t("Left")}</Typography>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <Radio
          disabled={isDisabled}
          checked={selectedEye === RIGHT}
          onChange={() => {
            onChangeEye(RIGHT);
          }}
          value="right eye"
          name="radio-buttons"
          inputProps={{ "aria-label": "right eye" }}
          sx={{
            padding: "0px",
            "&.MuiButtonBase-root.MuiRadio-root": {
              color: "#E2772E",
            },
          }}
        />
        <Typography sx={{ fontSize: "14px" }}>{t("Right")}</Typography>
      </Box>
    </Box>
  );
};

export default SelectEyeRadio;
